import React from 'react';
import { Typography } from 'src/components/PulseUI';
import { Checkbox } from 'src/components';
import { ExportPermissionItemProps } from '../types';
import { formatResourceName } from '../utils';
import { titleCase } from 'src/utils/titleCase/titleCase';

/**
 * Component for rendering a single export permission item
 */
const ExportPermissionItem: React.FC<ExportPermissionItemProps> = ({
  permission,
  selectedPermissions,
  onSelectPermission,
}) => {
  const resourceName = formatResourceName(permission.resource);

  return (
    <div
      data-testid={`export-permission-${permission.resource}-${permission.scope}`}
      className="flex items-center p-3 hover:bg-neutral-50/80 transition-colors group border rounded-lg"
    >
      <div className="flex flex-1 items-center">
        <div className="flex flex-col flex-1">
          <Typography className="text-sm font-medium text-neutral-700 group-hover:text-neutral-900">
            {titleCase(resourceName)}
          </Typography>
          <Typography className="text-xs text-neutral-500 line-clamp-2">
            {permission.description}
          </Typography>
        </div>
        <div className="flex justify-end">
          <Checkbox
            size="sm"
            checked={selectedPermissions.includes(permission.permissionCode)}
            onChange={() => onSelectPermission(permission.permissionCode)}
            data-testid={`export-checkbox-${permission.permissionCode}`}
          />
        </div>
      </div>
    </div>
  );
};

export default ExportPermissionItem;
